// /** @jsxImportSource @emotion/react */
import tw from "twin.macro";
import styled from 'styled-components';
import { Icon } from '@selfbook/atoms-v2';
import { POPOUT_DIRECTION } from '../../hooks';
import { Popout } from '../../styles/common.styled';

export const Wrapper = styled.div`
  ${tw`antialiased relative hidden`}
  ${({ $colorTheme, $theme }) => `
    background-color: var(--sb-widget-bgcolor, ${$theme?.get(`tokens.surface.${$colorTheme || 'light'}.background`) || '#FFFFFF'});
    color: var(--sb-widget-bgcolor, ${$theme?.get(`tokens.text.${$colorTheme || 'light'}.primary`) || '#000000'});
  `}
  border-radius: var(--sb-widget-radius, 999px);
  padding: var(--sb-widget-padding, 6px);

  ${({ $theme }) => `
    @media ${$theme?.get('tokens.breakpoints.medium').toExpression()} {
      display: var(--desktop-display, block);
    }
  `}

  button i {
    flex: none;
    min-width: 0;
  }
`;

export const Row = styled.div`
  ${tw`flex items-center`}
  ${({ $flex }) => $flex === 'none' ? tw`flex-none` : $flex === 'grow' ? tw`flex-1` : null}
  ${({ $justify }) => $justify === 'between' && tw`justify-between`}
  ${({ $padLeft }) => $padLeft && tw`pl-4`}
`;

export const TriggerDiv = styled.div`
  ${tw`flex-none relative`}

  ${Popout} {
    --popout-offset: calc(8px + var(--sb-widget-padding));
  }
`;

export const TriggerEllipsis = styled.div`
  ${tw`overflow-hidden text-ellipsis whitespace-nowrap`}
  flex: 1 1 0;
  max-width: 100%;
  width: fit-content;
`;

export const TriggerIcon = styled(Icon)`
  ${tw`hidden`}

  ${({ $theme }) => `
    @media ${$theme?.get('tokens.breakpoints.large').toExpression()} {
      display: block;
    }
  `}
`;
